.popover {
	background-color: var(--color-surface);
	border: var(--size-border) solid var(--color-border);
	border-radius: var(--radius-lg);
	corner-shape: squircle;
	box-shadow: var(--shadow-md);

	&[popover="hint"],
	&[popover="manual"] {
		background-color: transparent;
		border: none;
		border-radius: 0;
		box-shadow: none;
		overflow: visible;
	}

	/* follow the app theme even when a container overrides color-scheme */
	@container style(--theme: light) {
		color-scheme: light;
	}
	@container style(--theme: dark) {
		color-scheme: dark;
	}
}

/* enter and leave animations */

.popover {
	--show-duration: 0.2s;
	--hide-duration: 0.1s;
	--hidden-opacity: 0;
	--hidden-scale: 0.95;
	--transform-origin-x: center;
	--transform-origin-y: center;

	&[data-placement^="top"] {
		--transform-origin-y: bottom;
	}

	&[data-placement^="bottom"] {
		--transform-origin-y: top;
	}

	&[data-placement$="start"] {
		--transform-origin-x: left;
	}

	&[data-placement$="end"] {
		--transform-origin-x: right;
	}

	display: none;
	opacity: var(--hidden-opacity);
	scale: var(--hidden-scale);
	transform-origin: var(--transform-origin-x) var(--transform-origin-y);
	transition:
		display var(--hide-duration) allow-discrete,
		overlay var(--hide-duration) allow-discrete,
		scale var(--hide-duration) ease,
		opacity var(--hide-duration) ease;

	&:popover-open {
		display: flex;
		flex-direction: column;
		opacity: 1;
		scale: 1;
		translate: 0;
		transition-duration: var(--show-duration);

		@starting-style {
			opacity: var(--hidden-opacity);
			scale: var(--hidden-scale);
		}
	}
}
